export var BIBLIOTECA_ARQUIVOS_URL = 'biblioteca-arquivos';
export var BIBLIOTECA_ARQUIVOS_QUERY_KEY = 'biblioteca-arquivos';
export var TITULO_BIBLIOTECA_ARQUIVOS = 'Biblioteca de Arquivos';
